import { CloseOutlined } from '@ant-design/icons';
import { Avatar, Drawer, Empty, List, Modal, Typography } from 'antd';
import { useGetNotificationsList } from 'features/users/use-cases/get-notificationsList';
import { ReadallNotification } from 'features/users/use-cases/read-notification';
import { UpdateNotification } from 'features/users/use-cases/update-notification';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

export const NotificationheaderView = ({
  closeNotificationDrawer,
  isDrawerOpen,
}: {
  closeNotificationDrawer: () => void;
  isDrawerOpen: boolean;
}) => {
  const navigate = useNavigate();
  const { data: NotificationData, refetch } = useGetNotificationsList(
    '' as any,
    {
      enabled: isDrawerOpen,
    } as any,
  );
  const { mutate } = UpdateNotification();
  const { mutate: readall } = ReadallNotification();

  // ReadallNotification
  const [notificationList, setNotificationList] = useState<any[]>([]);

  useEffect(() => {
    if (isDrawerOpen) {
      refetch();
    }
  }, [isDrawerOpen]);

  useEffect(() => {
    if (NotificationData?.Data?.length) {
      setNotificationList(NotificationData.Data);
    }
  }, [NotificationData]);

  // ❌ Remove single notification
  const handleDismiss = (index: number, item: any) => {
    const payload = {
      id: item?.Id,
      isMessageRead: true,
    };
    mutate(payload);
    setNotificationList((prev) => prev.filter((_, i) => i !== index));
  };

  // ✅ Clear all notifications
  const handleClearAll = () => {
    Modal.confirm({
      title: 'Are you sure you want to clear all notifications?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        const ids = notificationList.map((item) => item?.Id);
        const payload: any = {
          Id: ids, // array of IDs
        };
        readall(payload);
        setNotificationList([]);
      },
    });
  };
  const handleNotificationClick = (item: any) => {
    if (item?.BookingId) {
      navigate(`/bookings/${item.BookingId}/edit`);
      closeNotificationDrawer();
    }
  };

  return (
    <Fragment>
      <Drawer
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Title level={4} style={{ margin: 0 }}>
              Notifications
            </Title>
            {notificationList.length > 0 && (
              <Text
                type='secondary'
                style={{
                  cursor: 'pointer',
                  fontSize: 12,
                }}
                onClick={handleClearAll}
              >
                Clear All
              </Text>
            )}
          </div>
        }
        placement='right'
        onClose={closeNotificationDrawer}
        open={isDrawerOpen}
        width={380}
        bodyStyle={{ padding: '16px 24px' }}
        closeIcon={
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 28,
              height: 28,
              borderRadius: '50%',
              backgroundColor: '#f0f0f0',
              cursor: 'pointer',
            }}
          >
            <CloseOutlined style={{ fontSize: 14, color: '#555' }} />
          </span>
        }
      >
        {notificationList.length > 0 ? (
          <List
            itemLayout='horizontal'
            dataSource={notificationList}
            renderItem={(item: any, index: number) => (
              <List.Item
                style={{ padding: '12px 0' }}
                actions={[
                  <CloseOutlined
                    key='close'
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDismiss(index, item);
                    }}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      backgroundColor: '#f0f0f0',
                      color: '#999',
                      cursor: 'pointer',
                      transition: 'all 0.3s',
                    }}
                  />,
                ]}
                onClick={() => handleNotificationClick(item)}
              >
                <List.Item.Meta
                  avatar={
                    <Avatar
                      style={{ backgroundColor: '#1890ff' }}
                      icon={
                        <span style={{ fontSize: '14px', color: '#fff' }}>
                          📝
                        </span>
                      }
                    />
                  }
                  title={<Text strong>{item.Title ?? 'New Message'}</Text>}
                  description={
                    <Text type='secondary'>{item.Message ?? 'No Message'}</Text>
                  }
                />
              </List.Item>
            )}
          />
        ) : (
          <Empty description='No notifications available' />
        )}
      </Drawer>
    </Fragment>
  );
};
